import 'roboto-fontface/css/roboto/sass/roboto-fontface-regular.scss';
import '@mdi/font/css/materialdesignicons.css';
import 'animate.css/animate.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import './styles/styles.scss';
import './plugins/vue-rx';
import './plugins/highcharts';
import App from './App.vue';
import router from './router';
import store from './store';
import ZoomOnHover from 'vue-zoom-on-hover';
Vue.use(ZoomOnHover)

// import './plugins/sentry';
Vue.config.productionTip = false;
Vue.config.devtools = true;
const appInstance = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');


